export default "__VITE_ASSET__DUFERVKy__"